import { PROJECTS_CONFIG, GLOBAL_TOKENS, LEGACY_CONTRACTS } from "../config/projectsConfig";

/**
 * AUTO-GENERATED ENVIRONMENT
 * This file is automatically populated from projectsConfig.js
 * DO NOT manually add projects here - update projectsConfig.js instead
 */

// Auto-generate project-specific environment variables
function capitalizeFirstLetter(str) {
  str = str.toLowerCase()
  // Handle empty or non-string inputs gracefully
  if (!str || typeof str !== 'string') {
    return str;
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}
const generateProjectEnv = () => {
  const env = {};

  PROJECTS_CONFIG.forEach((project) => {
    const id = project.id;

    // Add main contracts
    if (project.contracts.preSale) {
      env[`${id}PreSale`] = project.contracts.preSale;
      env[`${capitalizeFirstLetter(id)}PreSale`] = project.contracts.preSale;
    }
    if (project.contracts.claim) {
      env[`${id}Claim`] = project.contracts.claim;
      env[`${capitalizeFirstLetter(id) }Claim`] = project.contracts.claim;
    }

    // Add main graph
    if (project.graph?.url) {
      env[`${id}Graph`] = project.graph.url;
      env[`${capitalizeFirstLetter(id) }Graph`] = project.graph.url;
    }

    // Add insurance if exists
    if (project.contracts.insurance) {
      env[`${id}Insurance`] = project.contracts.insurance;
      env[`${capitalizeFirstLetter(id) }Insurance`] = project.contracts.insurance;
    }

    // Add staking/subscription for GEMS
    if (project.contracts.staking) {
      env[`${id}Staking`] = project.contracts.staking;
    }
    if (project.contracts.subscription) {
      env[`${id}Subscription`] = project.contracts.subscription;
    }

    // Add versioned contracts
    if (project.contracts.versions) {
      Object.entries(project.contracts.versions).forEach(([version, contracts]) => {
        if (contracts.preSale) {
          env[`${id}PreSale${version.toUpperCase()}`] = contracts.preSale;
          env[`${capitalizeFirstLetter(id)}PreSale${version.toUpperCase()}`] = contracts.preSale;
        }
        if (contracts.claim) {
          env[`${id}Claim${version.toUpperCase()}`] = contracts.claim;
          env[`${capitalizeFirstLetter(id)}Claim${version.toUpperCase()}`] = contracts.claim;
        }
      });
    }

    // Add old claims for DOP
    if (project.contracts.oldClaims) {
      Object.entries(project.contracts.oldClaims).forEach(([key, address]) => {
        if (key === "rounds1_2") {
          env.Claims = address;
        } else if (key === "roundsGt2") {
          env.ClaimsNew = address;
        }
      });
    }

    // Add versioned graphs
    if (project.graph?.versions) {
      Object.entries(project.graph.versions).forEach(([version, url]) => {
        env[`${id}Graph${version.toUpperCase()}`] = url;
        env[`${capitalizeFirstLetter(id)}Graph${version.toUpperCase()}`] = url;
      });
    }

    // Add special graph properties
    if (project.graph?.staking) {
      env[`${id}StakingGraph`] = project.graph.staking;
    }
    if (project.graph?.subscription) {
      env[`${id}SubscriptionGraph`] = project.graph.subscription;
    }
    if (project.graph?.subscriptionV2) {
      env[`${id}SubscriptionGraph_v2`] = project.graph.subscriptionV2;
    }
    if (project.graph?.oldGraphUrl) {
      env.oldGraph = project.graph.oldGraphUrl;
    }
    if (project.id === "DOP" && project.graph?.url) {
      env.graph = project.graph.url;
    }

    // Add institution contracts for MATCHAIN
    if (project.id === "MATCHAIN") {
      env.MATCHAINInstitutionPreSale = "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181";
      env.MATCHAINinstitutionGraph = "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01";
    }
  });

  return env;
};

const Environment = {
  // Legacy/special contracts (keep for backward compatibility)
  TomiContract: "0x4385328cc4D643Ca98DfEA734360C0F596C83449",
  ...LEGACY_CONTRACTS,

  // Global tokens
  ...GLOBAL_TOKENS,

  // Auto-generated project contracts and graphs
  ...generateProjectEnv(),

  // Special case mappings for clarity
  get DOPRoundSingleContract() {
    return this.DOPPreSale;
  },
  get claimNewLatest() {
    return this.DOPClaim;
  },
};
console.log(Environment, 'EnvironmentEnvironment');

export default Environment;

// let Environment = {
//   TomiContract: "0x4385328cc4D643Ca98DfEA734360C0F596C83449",
//   // CreateDopRound: "0x6cE532764F3c7700cdA0967a6aC5B4f636201491", // main net contract
//   CreateDopRound: "0x2D4e8121AeE68679054018037832947a3E0Bcf8A",
//   // CreateNFTRound: "0x5C5576b7e36270A78A35495B5843Fc1EBb4b5FfE", //test net

//   CreateNFTRound: "0x1119c2d708E42Fb591FCe77283b0791a135855ba", //main net

//   CreateDopTomiRound: "0xf4Fa4f08811Ea1F79a809129192279d97D88EF51", //test net
//   // CreateNFTRound: "0x5C5576b7e36270A78A35495B5843Fc1EBb4b5FfE", //test net

//   CreateNFTTomiRound: "0xCFd7cB1528f32aDFFC40D2A7199E80799E4E4736", //test net

//   DOPRoundSingleContract: "0x2B316b6E4fFD1984a2dE9b33E42787923d77F390", // main net

//   InstitutionPreSale: "0x2E1858809393FaDb72D406Bb4E4699AD759e88fa", // main net

//   Claims: "0x08669B18fe3A661400ac8dddF837e90861BFf5B6", //this one is for rounds 1 and 2
//   ClaimsNew: "0x1B7168cA64fCd77fDF713767e6cDe2d7757241AB", // rounds greater then 2
//   oldGraph:
//     "https://api.studio.thegraph.com/query/51954/dopgraphcombined/version/latest", // for round smaller than or equal to 6
//   graph: "https://api.thegraph.com/subgraphs/name/saifdevblochain/presaledop", // for round greater then 6

//   institutionGraph:
//     "https://api.studio.thegraph.com/query/63987/institutionpresale-live/0.0.1",

//   claimNewLatest: "0x2cb197409ae65b344a611E2ab99A0E864EF28d4c",
//   busd: "0x6fEA2f1b82aFC40030520a6C49B0d3b652A65915", //testnet
//   tomi: "0x84f0bC91f23649c76139d402a1c00c6aC19A4400", //testnet
//   eth: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE", //testnet
//   usdc: "0x25762231808F040410586504fDF08Df259A2163c", //testnet
//   wbtc: "0x54410d42628C7fD6720C489219033345Bcb7Cc73", //testnet
//   // gems: "0xB297D4b01b286de35Ee12cdCe89Ec9488EEec0C2", //testnet
//   gems: "0x7ddd14e3a173a5db7bb8fd74b82b667f221492b9", //for node miner in testnet
//   pepe: "0x0592EBa69Aa5f2eF68d9cb740fBaB2c0c0CC6A91",
//   link: "0x37bBd68526C9BDb49f18fB36983701E344f2A163",
//   uni: "0x079c46A5Ba477400a326E03Ad8D22FaBeaE57b4F",
//   dop: "0xa048E46C35cf210bB0d5bb46b2DD06828Ef17893",


//   /////////// MATCHAIN

//   MATCHAINPreSale: "0xc36f3CBc4e29E3E54834E6e853163B05A9Eb2a6A",
//   MATCHAINClaim: "0xDa5dbE6506990EF7EC90E435F9CDC7A025b9BC3B",
//   MATCHAINGraph: "https://api.studio.thegraph.com/query/63987/matchain-staging/version/latest",
//   MATCHAINInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   MATCHAINinstitutionGraph:
//     "https://api.studio.thegraph.com/query/63987/incentive-institution-mainnet/01",



//   LUCKIFYPreSale: "0x90E5B93eE48105D131aeA7CF8f295879Ab4edE53",
//   LUCKIFYClaim: "0x2CFfc9dA6528abFa34ac80e1F0E16A473dc298bf",
//   LUCKIFYGraph: "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/luckify-tokensOnly-graph/api",
//   LUCKIFYInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   LUCKIFYinstitutionGraph:
//     "https://subgraph.satsuma-prod.com/323ce71d2cc0/usman--186639/luckify-tokensOnly-graph/api",


//   SCREXPreSale: "0x7D765A830e4f23843C0d78FACC7C1069BA197546",
//   SCREXClaim: "0x3233B1188D9082A177e9F14295D8Ddb9c9157249",
//   SCREXGraph: "https://api.studio.thegraph.com/query/112168/screxgraph-4/version/latest",
//   SCREXInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   SCREXinstitutionGraph:
//     "https://api.studio.thegraph.com/query/112168/screxgraph-4/version/latest",

//   CHAINERSPreSale: "0x84F44f2FDC9C2e2d78Fae77d2201F74b88a1bAd9",
//   CHAINERSClaim: "0x9861F09a319d098E8Ce0056cf92Fcc6ca96a0285",
//   CHAINERSGraph: "https://api.studio.thegraph.com/query/112168/chainersgraph/version/latest",
//   CHAINERSInstitutionPreSale: "0x72312fAfd5f58C8D44B1769b09A0F879ce93d181",
//   CHAINERSinstitutionGraph:
//     "https://api.studio.thegraph.com/query/112168/chainersgraph/version/latest",

    
//   TIGAPreSale: "0xDc66dae6C9efc40708276339658fAe7382841aC7",
//   TIGAClaim: "0xfaD66fe08fc07E106d2DE7d8bc5aE309beDDA2a5",
//   TIGAGraph: "https://api.studio.thegraph.com/query/112168/tigagraph/version/latest",


//   XPROTOCOLPreSale: "0x081b4cc44A48AD08009136570e5f6B857CAA9F8B",
//   XPROTOCOLClaim: "0xE9Fbe3cAcfACEf8EAd2c3Deea149E8f349eB6DC6",
//   XPROTOCOLGraph: "https://api.studio.thegraph.com/query/112168/x-protocol/version/latest",
//   /////// GEMS MAINNET
//   GemsStaking: "0x034f504F34330eA87dcc8aBae2935eac9fD2eFaE", //TESTNET
//   GemsSubscription: "0xe7Ad3a7EC2fdc8aa141dB9AFc1f701AAb579DA85", //TESTNET

//   GemsStakingGraph:
//     "https://api.studio.thegraph.com/query/63987/staking-gems-testnet/12", //Test Net

//   GemsSubscriptionGraph:
//     "https://api.studio.thegraph.com/query/75549/subscription-graph/version/latest", //TESTNET v1
//   GemsSubscriptionGraph_v2:
//     "https://api.studio.thegraph.com/query/80537/subscription-v2/version/latest", //TESTNET 2
//   GemsGraph:
//     "https://api.studio.thegraph.com/query/63987/gems-presale-main/latest1", //TESTNET

//   GemsClaim: "0x473F7c7757dd866520B8422de18635981701670e", //TESTNET
//   GemsPreSale: "0xA242cd6408641e16A51E91D565aE204eBe273F34", //TESTNET

//   //// Incentiv
//   IncentivGraph: "https://api.studio.thegraph.com/query/63987/abc-test/v-01", //TESTNET
//   IncentivClaim: "0xc625f377245713DAa97f6dcb865f6206C6c3F664", //TESTNET
//   IncentivPreSale: "0x8917FE03096Ce297064DB58e85faEEaBF8472BDC", //TESTNET

//   //// LEIA

//   LEIAPreSale: "0xa84D39FEc03802AbCACb110116712c373d5ddbc4",
//   LEIAClaim: "0x0443c376267D13AE16C7809C78d240C843C2b05C",
//   LEIAGraph: "https://api.studio.thegraph.com/query/75549/leia-graph/v0.0.10",
//   LEIAInsurance: "0x48bDe00C39e23C99125c36BaCa5E2B3B8CD74FB7",

//   //// OLYMPUS

//   OlympusPreSale: "0x7C94504340683d339268BD4ac8B1FBD8Bf73Ac97",
//   OlympusClaim: "0x1a006eA738aB36e6d25C2DD19e14f23a9F2CC7cC",
//   OlympusGraph: "https://api.studio.thegraph.com/query/75549/leia-graph/v2.2.3",
//   OlympusInsurance: "0x75399cc4C0E12AA40fDE35A327615cC1131Fa7d0",

//   ///////// NFA

//   NFAPreSale: "0x8246b57D50A25B48E0045f7c370b131c75bEbFBD",
//   NFAClaim: "0x55c581B29739e43d357e2b083F6839BdBb784Bc8",
//   NFAGraph:
//     "https://api.studio.thegraph.com/query/63987/nfa-graph/version/latest",
//   NFAInsurance: "0xBeFcE668Fc10bc6e335Dad50ed19095A47397E68",

//   ///////// ASTRO NOVA

//   AstroNovaPreSale: "0x4e9FD4bB3eAe2b909713B57644B814AA4a531cd3",
//   AstroNovaPreSaleV2: "0x5ac9755f906ca17EEBA8833A8D1d43fC3c2c000B",

//   AstroNovaClaim: "0xBCf3E7379A05Bdabd76F4AfD7f752BEd71765EE9",
//   AstroNovaClaimV2: "0xb403876ce7DEEfe827F6Dff03Fa672Fe60cC915D",

//   AstroNovaGraph:
//     "https://api.studio.thegraph.com/query/75549/astro-nova-subscription-lockup-graph/version/latest",

//   AstroNovaGraphV2:
//     "https://api.studio.thegraph.com/query/75549/sale-graph-v1/version/latest",

//   AstroNovaInsurance: "0xBeFcE668Fc10bc6e335Dad50ed19095A47397E68",

//   ///////// RAIN

//   RainPreSale: "0x81cdF76D3D932611566bF957e521698CC6B3f606",
//   RainPreSaleV2: "0xc80BDe419544b7481D5bD6665803B1C97557C046",
//   RainPreSaleV3: "0xEE285Ae618cf2e22C71D4BE82Ab0D6ab70A1FBBF",

//   RainClaim: "0xFF3e0397CB96DA223D14b4FC9DCd1361Beb99FD7",
//   RainClaimV2: "0x1fD57d52f110B3A3EF55de122d8eCcc1986Feea6",
//   RainClaimV3: "0x1f7f01cf788B60ddA3506711FB615659de169515",

//   RainGraph:
//     "https://api.studio.thegraph.com/query/63987/rain-presale-staging/version/latest",

//   RainGraphV2:
//     "https://api.studio.thegraph.com/query/75549/rain-presale-insurance-graph/version/latest",

//   RainGraphV3:
//     "https://api.studio.thegraph.com/query/63987/rain-subscription-lockup/version/latest",

//   RainInsurance: "0xBeFcE668Fc10bc6e335Dad50ed19095A47397E68",

//   ///////// MINERS CLAIMS
//   MinersClaimOld: "0xc953205A194dCd816Dbcd4078Ee35BfC4c9462F0",

//   MinersClaim: "0xd5aa42D33587d4C8815fe1669E782eA5a2Ce3EE4",
//   MinersClaimV2: "0xd5aa42D33587d4C8815fe1669E782eA5a2Ce3EE4",

//   MinersGraphOld:
//     " https://api.studio.thegraph.com/query/75549/node-miner-discounted-graph/version/latest",

//   MinersGraph:
//     "https://api.studio.thegraph.com/query/75549/node-miner-week-staging/version/latest",
//   MinersGraphV2:
//     "https://api.studio.thegraph.com/query/75549/node-miner-week-staging/version/latest",
// };
// export default Environment;
